import React from "react";
import Footer from "@components/footer";
import NavBar from "@components/nav-bar";
import usePersistParams from "custom-hooks/usePersistParams.hook";
import WhatsAppFloatButton from "../whatssp-float-button";
interface ILayoutProps {
  children: any;
  showFooter?: boolean;
  backgroundColorFooter?: string;
}

export default function Layout({
  children,
  showFooter,
  backgroundColorFooter,
}: ILayoutProps) {
  usePersistParams();

  return (
    <>
      {/* <WhatsAppFloatButton /> */}
      <NavBar />
      <main>{children}</main>

      {showFooter && (
        <section style={{ backgroundColor: backgroundColorFooter }}>
          <Footer />
        </section>
      )}
    </>
  );
}
